import { getCurrencySymbol as $getCurrencySymbol } from "@npco/web-utils";

export function getCurrencySymbol(currency?: string) {
	return $getCurrencySymbol(currency);
}
